
import { message } from "antd";
import FetchData from '@ezviz/FetchData';
import moment from "moment";
import util from './../../utils/utils';
import intl from 'react-intl-universal';
export const UPDATE_LOADING_STATUS = "UPDATE_LOADING_STATUS";
export const FETCH_MODULE_LIST = "FETCH_MODULE_LIST";


moment.locale("zh-cn");

message.config({
  top: 300,
  maxCount: 3
});

export function updateLoadingStatus(loading) {
  return (dispatch, getState) => {
    dispatch({
      type: UPDATE_LOADING_STATUS,
      loading
    });
  };
}

// 查询模组列表
export function fetchModuleList(param, callback) {
  return (dispatch, getState) => {
    const { productId } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/modules/by/category/${productId}`, {
      method: 'GET',
      headers: {},
      // body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          console.log('res', res)
          dispatch({
            type: FETCH_MODULE_LIST,
            moduleList: res.data || []
          });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}


// 选择模组
export function selectModule(param, callback) {
  return (dispatch, getState) => {
    const { pId, moduleId } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/config/module?pId=${pId}&moduleId=${moduleId}`, {
      method: 'POST',
      headers: {},
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          console.log('this', res)
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));
      });
  };
}

// 查询固件列表
export function fetchFirmwareList(param, callback) {
  return (dispatch, getState) => {
    const { moduleId, pId, pageIndex = 0, pageSize = 100 } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/latest?moduleId=${moduleId}&pId=${pId}&pageIndex=${pageIndex}&pageSize=${pageSize}`, {
      method: 'GET',
      headers: {},
      // body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          // dispatch({
          //   type: FETCH_MODULE_LIST,
          //   moduleList: res.data || []
          // });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 查询自定义固件列表
export function fetchCustomFirmwareList(param, callback) {
  return (dispatch, getState) => {
    const { pId, moduleId, developType } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/config/list?pId=${pId}&moduleId=${moduleId}&developType=${developType}`, {
      method: 'GET',
      headers: {},
      // body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          // dispatch({
          //   type: FETCH_MODULE_LIST,
          //   moduleList: res.data || []
          // });
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 选择固件-基础
export function selectFirmware(param, callback) {
  return (dispatch, getState) => {
    const body = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/select`, {
      method: 'POST',
      headers: {},
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 新增自定义固件
export function addFirmware(param, callback) {
  return (dispatch, getState) => {
    const body = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/customize`, {
      method: 'POST',
      headers: {},
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          message.success(res.msg || intl.get('commmon.operate.success'));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 编辑自定义固件
export function updateFirmware(param, callback) {
  return (dispatch, getState) => {
    const body = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/customize/update`, {
      method: 'POST',
      headers: {},
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          message.success(res.msg || intl.get('commmon.operate.success'));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}


// 删除自定义固件
export function deleteFirmware(param, callback) {
  return (dispatch, getState) => {
    const { pId, firmwareId, firmwareVersion } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/customize/delete?pId=${pId}&firmwareId=${firmwareId}&firmwareVersion=${firmwareVersion}`, {
      method: 'POST',
      headers: {},
      // body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
          message.success(res.msg || intl.get('commmon.operate.success'));
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}


// 开发方式选择
export function setDevelopType(param, callback) {
  return (dispatch, getState) => {

    const { pId, developType } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/module/developType?pId=${pId}&developType=${developType}`, {
      method: 'POST',
      headers: {},
      // body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 开发方式选择
export function getSdkTool(param, callback) {
  return (dispatch, getState) => {

    const { moduleId } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/sdkTool/list?moduleId=${moduleId}`, {
      method: 'POST',
      headers: {},
      // body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 开发方式选择
export function getFWVersionList(param, callback) {
  return (dispatch, getState) => {

    const { moduleId, firmwareId, pId } = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/list?moduleId=${moduleId}&firmwareId=${firmwareId}&pId=${pId}`, {
      method: 'POST',
      headers: {},
      // body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}

// 修改免开发固件信息配置
export function saveNodevHardwareConfig(param, callback) {
  return (dispatch, getState) => {

    const { pId, moduleId, mConfigInfo } = param;
    const body = param;
    const fetchData = new FetchData(`/iot/config/api/iot/support/firmware/online/config`, {
      method: 'POST',
      headers: {},
      body,
      metaHandler: {
        403: () => { window.location.href = '/authrization/login'; return; }
      },
    });
    fetchData
      .then(res => {
        callback(res);
        if (res.code == 200) {
        } else {
          message.error(res.msg || intl.get('commmon.operate.retry'));
        }
      })
      .catch(e => {
        message.error(intl.get('commmon.operate.netRetry'));

      });
  };
}


